export const DETAIL_OPTION = 'DETAIL_OPTION'
export const LIST_OPTION = 'LIST_OPTION'
